import { Button, ClickAwayListener, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import './AffiliationsTooltip.scss';

type Props = {
    readonly tooltipAffiliations: string[];
    readonly firstAffiliationName: string;
    readonly moreCount: number;
    readonly l: l;
    readonly seleniumid: string;
    readonly showAllInline?: boolean;
};

function AffiliationsTooltip({
    firstAffiliationName,
    l,
    moreCount,
    seleniumid,
    showAllInline,
    tooltipAffiliations,
}: Props) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const handleTooltipClose = () => setTooltipOpen(false);
    const allAffiliations = [firstAffiliationName, ...tooltipAffiliations].filter(Boolean);

    if (showAllInline) {
        return (
            <div className="affiliations-inline-list" data-seleniumid={`${seleniumid}-affiliations-list`}>
                {allAffiliations.map(name => (
                    <div key={name} className="affiliations-inline-list-item">
                        {name}
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            {firstAffiliationName}
            <br />
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    aria-describedby={`${seleniumid}-tooltip-content`}
                    arrow
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    onClose={handleTooltipClose}
                    open={tooltipOpen}
                    placement="bottom"
                    role="tooltip"
                    slotProps={{
                        arrow: {
                            sx: theme => ({
                                color: theme.palette.common.white,
                            }),
                        },
                        popper: {
                            disablePortal: true,
                        },
                        tooltip: {
                            sx: theme => ({
                                alignItems: 'center',
                                bgcolor: theme.palette.background.paper,
                                boxShadow: theme.shadows[4],
                                color: theme.palette.text.primary,
                                display: 'inline-flex',
                                flexDirection: 'column',
                                padding: theme.spacing(1.875),
                            }),
                        },
                    }}
                    title={
                        <div data-seleniumid={`${seleniumid}-more-affiliations-tooltip`}>
                            <div className="tooltip-title">Other affiliations:</div>
                            <ul className="tooltip-list">
                                {tooltipAffiliations.map(name => (
                                    <li key={name}>{name}</li>
                                ))}
                            </ul>
                        </div>
                    }
                >
                    <Button
                        aria-expanded={tooltipOpen}
                        aria-haspopup="true"
                        className="affiliations-tooltip-button"
                        data-seleniumid={`${seleniumid}-more-affiliations-btn`}
                        onClick={e => {
                            e.stopPropagation();
                            setTooltipOpen(true);
                        }}
                    >
                        {`+${moreCount} ${l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_PRICE_CHANGE_MORE_AFFILIATIONS')}`}
                    </Button>
                </Tooltip>
            </ClickAwayListener>
        </>
    );
}

export default AffiliationsTooltip;
